import { Typography } from "@mui/material";

const LableComponent = (props) => {
  return (
    <Typography
      variant="customLable"
      color="common.inputCustomLable"
      marginBottom={1}
    >
      {props?.customLable}
      {!props?.isNotRequired && <span style={{ color: "#C50F1F" }}> *</span>}
    </Typography>
  );
};
export default LableComponent;
